<div id="toggler" class="d-flex py-2" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    @if (!showFleetLinkInEquipmentHistory) {
        <div class="col-4 user-select-auto" id="notification-num">
            {{ history.notificationNo.value }}
        </div>
    }
    @if (showFleetLinkInEquipmentHistory) {
        <div class="col-4 user-select-auto" paceCoreLink>
            <a
                class="pace-link"
                href="{{ teamPlayFleetLink }}{{
                    history.notificationType.value === notificationType.Service ? 'ticketHistory' : 'activity'
                }}&search={{ history.notificationNo.value }}"
                target="_blank"
            >
                {{ history.notificationNo.value }}
            </a>
        </div>
    }
    <div class="col-2 user-select-auto">{{ history.notificationType.value }}</div>
    <div class="col-2 wrap-word text-break user-select-auto">{{ history.shortText.value }}</div>
    <div class="col-3 user-select-auto">{{ history.createdDate.formattedDisplayedDate }}</div>
</div>
@if (!isCollapsed) {
    <div
        class="material-expanded-content py-3 offset-1"
        [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
        tabindex="0"
    >
        <tabset paceCoreTabsRole>
            <tab [heading]="'NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_ALL' | translate">
                <ul class="list-group mt-1" id="all-text-tab">
                    @for (historyItem of historyAll; track historyItem) {
                        <li class="list-group-item" [attr.data-notification-no]="historyItem.NotificationNo">
                            {{ historyItem.TextLine }}
                        </li>
                    }
                </ul>
            </tab>
            @if (displayErrorReportsTab || historyError.length) {
                <tab [heading]="'NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_ERROR_REPORT' | translate">
                    <ul class="list-group mt-1">
                        @for (historyItem of historyError; track historyItem) {
                            <li class="list-group-item" [attr.data-notification-no]="historyItem.NotificationNo">
                                {{ historyItem.TextLine }}
                            </li>
                        }
                    </ul>
                </tab>
            }
            @if (displayMaterialTab || historyMaterial.length) {
                <tab [heading]="'NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_MATERIAL' | translate">
                    <ul class="list-group mt-1">
                        @for (historyItem of historyMaterial; track historyItem) {
                            <li class="list-group-item" [attr.data-notification-no]="historyItem.NotificationNo">
                                {{ historyItem.TextLine }}
                            </li>
                        }
                    </ul>
                </tab>
            }
        </tabset>
    </div>
}
